import Dialog, {
  DialogProps,
} from '$tablet-app/src/app/components/Dialog/Dialog';
import { SelectionPanel } from '$tablet-app/src/app/components/SelectionPanel/SelectionPanel';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { View } from 'react-native';
import styled from 'styled-components/native';

interface Props extends DialogProps {
  onSubmit(value: string): void;
}

export const AddContactDetailModal = ({ onSubmit, ...props }: Props) => {
  return (
    <StyledDialog size="mc" {...props}>
      <Header>
        <View />
        <Text variant="h3" weight="semibold">
          What do you want to add?
        </Text>
        <Button variant="secondary" icon="times" onPress={props.onClose} />
      </Header>

      <PanelRow>
        {detail_options.map((option) => (
          <SelectionPanel key={option.value} {...option} onPress={onSubmit} />
        ))}
      </PanelRow>
    </StyledDialog>
  );
};

const StyledDialog = styled(Dialog)`
  padding: 30px 50px 50px;
  gap: 25px;
`;

interface DetailOption {
  icon?: IconProp;
  iconColor?: string;
  backgroundColor?: string;
  title: string;
  subtitle?: string;
  value: string;
}

const detail_options: DetailOption[] = [
  {
    value: 'phone',
    title: 'Phone',
    icon: 'phone',
    iconColor: colors.secondary[700],
    backgroundColor: colors.blue.background,
  },
  {
    value: 'email',
    title: 'Email',
    icon: 'envelope',
    iconColor: colors.orange.crayola,
    backgroundColor: colors.orange.background,
  },
  {
    value: 'address',
    title: 'Address',
    icon: 'map-marker-alt',
    iconColor: colors.green[700],
    backgroundColor: colors.green.todo_list_background,
  },
  {
    value: 'note',
    title: 'Note',
    icon: 'sticky-note',
    iconColor: colors.yellow[700],
    backgroundColor: colors.yellow.background,
  },
];

const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;

const PanelRow = styled.View`
  flex-direction: row;
  gap: 25px;
`;
